import { createContext, Dispatch, ReactNode, useMemo, useReducer } from "react";

import type { Tour, TourAction, TourState } from "@/libs/tours/types";
import type React from "react";

import { initialState, tourReducer } from "./state";
import { useTourEvents } from "../hooks/useTourEvents";

interface TourContextType extends TourState {
  setContext: Dispatch<TourAction>;
}

export const TourContext = createContext<TourContextType | undefined>(
  undefined,
);

export function TourProvider({ children }: { children: ReactNode }) {
  const [state, setContext] = useReducer(tourReducer, initialState);

  useTourEvents(state.tours, setContext);

  const values = useMemo(
    () => ({
      ...state,
      setContext,
    }),
    [state],
  );

  return <TourContext.Provider value={values}>{children}</TourContext.Provider>;
}
